'use client';

import { AuthCard } from '@/modules/authentication/presentation/components';
import { ForgotPasswordForm } from '@/modules/authentication/presentation/forms';
import type { ForgotPasswordFormModel } from '@/modules/authentication/view-model';
import { ForgotPasswordFormSchema, useForgotPasswordForm } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const ForgotPasswordContainer = () => {
	const { execute } = useForgotPasswordForm();

	return (
		<AuthCard>
			<Form.Provider<ForgotPasswordFormModel> onSubmit={execute} schema={ForgotPasswordFormSchema}>
				<ForgotPasswordForm />
			</Form.Provider>
		</AuthCard>
	);
};
